
export function decodeHtml(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
export const landingPageEvent = () => {
  if (window.fbq)
    window.fbq('track', 'Lead-Landing-page')
}
export const landingSpringPageEvent = () => {

  if (window.fbq)
    window.fbq('track', 'Lead-SpringH2O-page')
}
export const checkoutPageEvent = (totalAmount = 0) => {

  if (window.fbq)
    window.fbq('track', 'Lead-Checkout-page',
      {
        value: totalAmount,
        currency: 'INR',
      }
    )
}
export const loginPageEvent = () => {

  if (window.fbq)
    window.fbq('track', 'Lead-Login-page')
}
export const addToCartEvent = () => {

  if (window.fbq)
    window.fbq('track', 'Lead-Add-to-Cart')
}
const setAuthorizationToken = (token) => {
  //     const authToken = store.getState()
  // const token=authToken.authReducer.userData
  if (token) {
    //  instance.defaults.headers.Authorization = `Bearer ${token}`;
  }
}
export const loadRazorpay = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
};

export default setAuthorizationToken;